// src/components/Lobby.jsx
import React, { useContext, useState, useEffect } from 'react';
import { GameContext } from '../context/GameContext';

const Lobby = () => {
  const { gameState, joinLobby, startGame } = useContext(GameContext);
  const [name, setName] = useState('');
  const [teamMode, setTeamMode] = useState('2v2');

  useEffect(() => {
    console.log('🎮 Players in game:', gameState?.players);
  }, [gameState]);

  // Add New Game button handler
  const handleNewGame = () => {
    localStorage.removeItem('gameId');
    window.location.href = '/';
  };

  const handleJoin = () => {
    if (name.trim()) joinLobby(name.trim());
  };

  const handleStart = () => {
    startGame(teamMode);
  };

  const canStart = gameState?.players?.length >= 1;

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1e5a3e 0%, #2d7a4f 50%, #1e5a3e 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '500px',
        width: '100%',
        backgroundColor: 'white',
        boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
        borderRadius: '20px',
        overflow: 'hidden'
      }}>
        {/* Header Section */}
        <div style={{
          background: 'linear-gradient(135deg, #1e5a3e, #2d7a4f)',
          padding: '32px 24px',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '4rem',
            marginBottom: '12px'
          }}>
            ♠️♥️♣️♦️
          </div>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            color: 'white',
            marginBottom: '8px',
            textShadow: '0 2px 4px rgba(0,0,0,0.2)'
          }}>
            28
          </h1>
          <p style={{
            color: 'rgba(255,255,255,0.9)',
            fontSize: '1rem',
            fontWeight: '500'
          }}>
            Classic Indian Trick-Taking Game
          </p>
        </div>

        {/* Content Section */}
        <div style={{ padding: '32px 24px' }}>

      {gameState?.state?.phase && gameState.state.phase !== 'lobby' && (
        <div style={{
          marginBottom: '24px',
          padding: '20px',
          backgroundColor: '#fef3c7',
          border: '2px solid #fbbf24',
          borderRadius: '12px',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '1.1rem',
            color: '#92400e',
            marginBottom: '16px',
            fontWeight: '600'
          }}>
            🎮 Game already in progress
          </p>
          <button
            onClick={handleNewGame}
            style={{
              width: '100%',
              padding: '14px 24px',
              backgroundColor: '#d97706',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#b45309'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#d97706'}
          >
            🎲 Start New Game
          </button>
        </div>
      )}

      {/* Join Section */}
      <div style={{ marginBottom: '28px' }}>
        <label style={{
          display: 'block',
          fontSize: '0.95rem',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '8px'
        }}>
          What's your name?
        </label>
        <input
          type="text"
          placeholder="Enter your name"
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && name.trim()) {
              handleJoin();
            }
          }}
          style={{
            width: '100%',
            padding: '16px',
            marginBottom: '16px',
            border: '2px solid #d1d5db',
            borderRadius: '12px',
            fontSize: '1.1rem',
            minHeight: '56px',
            boxSizing: 'border-box',
            transition: 'all 0.2s',
            outline: 'none'
          }}
          onFocus={(e) => e.currentTarget.style.borderColor = '#2563eb'}
          onBlur={(e) => e.currentTarget.style.borderColor = '#d1d5db'}
        />
        <button
          onClick={handleJoin}
          disabled={!name.trim()}
          style={{
            width: '100%',
            padding: '16px',
            backgroundColor: name.trim() ? '#2563eb' : '#9ca3af',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '1.2rem',
            fontWeight: '600',
            cursor: name.trim() ? 'pointer' : 'not-allowed',
            minHeight: '56px',
            transition: 'all 0.2s',
            boxShadow: name.trim() ? '0 4px 6px rgba(37, 99, 235, 0.2)' : 'none'
          }}
          onMouseEnter={(e) => {
            if (name.trim()) {
              e.currentTarget.style.backgroundColor = '#1d4ed8';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(37, 99, 235, 0.3)';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = name.trim() ? '#2563eb' : '#9ca3af';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = name.trim() ? '0 4px 6px rgba(37, 99, 235, 0.2)' : 'none';
          }}
        >
          🎯 Join Game
        </button>
      </div>

      {canStart && (
        <div style={{
          backgroundColor: '#f0fdf4',
          border: '3px solid #10b981',
          borderRadius: '16px',
          padding: '24px',
          marginTop: '8px',
          boxShadow: '0 4px 12px rgba(16, 185, 129, 0.15)'
        }}>
          <div style={{
            textAlign: 'center',
            marginBottom: '20px'
          }}>
            <span style={{
              fontSize: '2rem',
              marginBottom: '8px',
              display: 'block'
            }}>
              ✅
            </span>
            <p style={{
              fontSize: '1rem',
              fontWeight: '600',
              color: '#047857'
            }}>
              Ready to play!
            </p>
          </div>

          {/* Team Mode Section */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '1rem',
              fontWeight: '600',
              color: '#065f46',
              marginBottom: '10px'
            }}>
              Select team format
            </label>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '12px'
            }}>
              <button
                onClick={() => setTeamMode('2v2')}
                style={{
                  padding: '16px',
                  backgroundColor: teamMode === '2v2' ? '#10b981' : 'white',
                  color: teamMode === '2v2' ? 'white' : '#065f46',
                  border: `2px solid ${teamMode === '2v2' ? '#10b981' : '#d1fae5'}`,
                  borderRadius: '12px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                👥👥<br/>2v2
              </button>
              <button
                onClick={() => setTeamMode('3v3')}
                style={{
                  padding: '16px',
                  backgroundColor: teamMode === '3v3' ? '#10b981' : 'white',
                  color: teamMode === '3v3' ? 'white' : '#065f46',
                  border: `2px solid ${teamMode === '3v3' ? '#10b981' : '#d1fae5'}`,
                  borderRadius: '12px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                👥👥👥<br/>3v3
              </button>
            </div>
          </div>

          {/* Start Button */}
          <button
            onClick={handleStart}
            style={{
              width: '100%',
              padding: '18px',
              backgroundColor: '#10b981',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: '1.3rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 6px 16px rgba(16, 185, 129, 0.3)',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#059669';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(16, 185, 129, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#10b981';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.3)';
            }}
          >
            🎮 Start Game
          </button>
        </div>
      )}
        </div>
      </div>
    </div>
  );
};

export default Lobby;
